<template>
  <div class="main-wrapper blog">
    <user-header></user-header>
    <breadcrumb :title="title" :text="text" :text1="text1" />
    <div class="content blog-grid carousal-blog">
      <div class="container">
        <div class="featured-slider-group p-0">
          <div class="owl-carousel blog-slider owl-theme">
            <!-- Blog -->
            <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
              <Slide v-for="item in Blog_Carousel" :key="item.id">
                <div class="featured-venues-item">
                  <div class="listing-item mb-0">
                    <div class="listing-img">
                      <router-link to="/blog/blog-details">
                        <img
                          :src="require(`@/assets/img/venues/${item.Images}`)"
                          alt="Venue"
                        />
                      </router-link>
                      <div class="fav-item-venues news-sports">
                        <span class="tag tag-blue">{{ item.Sports }}</span>
                        <div class="list-reviews coche-star">
                          <a
                            href="javascript:void(0)"
                            class="fav-icon"
                            @click="toggleSelected(item)"
                          >
                            <i class="feather-heart"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <div class="listing-content news-content">
                      <div class="listing-venue-owner">
                        <div class="navigation">
                          <a href="javascript:void(0)"
                            ><img
                              :src="require(`@/assets/img/profiles/${item.User}`)"
                              alt="User"
                            />{{ item.Name }}</a
                          >
                          <span><i class="feather-calendar"></i>{{ item.Date }}</span>
                        </div>
                      </div>
                      <h3 class="listing-title blog-title text-start">
                        <a href="javascript:void(0)">{{ item.Title }}</a>
                      </h3>
                      <div class="listing-button read-new">
                        <ul class="nav">
                          <li><i class="feather-heart"></i>{{ item.Like }}</li>
                          <li>
                            <i class="feather-message-square"></i>{{ item.Comment }}
                          </li>
                        </ul>
                        <span
                          ><img
                            :src="require(`@/assets/img/icons/${item.Clock}`)"
                            alt="Icon"
                          />{{ item.LastSeen }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </Slide>
              <template #addons>
                <Navigation />
              </template>
            </Carousel>
            <!-- /Blog -->
          </div>
        </div>
      </div>
    </div>
  </div>
  <layout-footer></layout-footer>
</template>
<script>
import { Carousel, Navigation, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import Blog_Carousel from "@/assets/json/blog-carousel.json";
export default {
  data() {
    return {
      Blog_Carousel: Blog_Carousel,
      title: "Blog Carousal",
      text: "Home",
      text1: "Blog Carousal",
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },
      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        991: {
          itemsToShow: 2,
          snapAlign: "start",
        },
        1024: {
          itemsToShow: 3,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Navigation,
  },
  methods: {
    toggleSelected(item) {
      item.isSelected = !item.isSelected;
    },
  },
};
</script>
